module.exports = __webpack_public_path__ + "static/media/belasting-2.1f24c444.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/belasting-2.svg
// module id = 117
// module chunks = 0